import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { CreateSubsetRequestDto } from '../../../../backend/src/subset/dto/create-subset.request.dto';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useCreateDocSubset = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ matterId, body }: { matterId: string; body: CreateSubsetRequestDto }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          ...body,
        },
      });

      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset`, fetchConfig);

      if (!res.ok) {
        // Extract error message from backend response
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to create doc subset: ${res.statusText}`);
      }

      return res.json();
    },
    onSuccess: (data) => {
      toast.success('Document subset created successfully');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.DocSubsets, { matterId: data.matterId }] });
      queryClient.invalidateQueries([QueryEntity.User]);
    },
    onError: (error: Error) => {
      console.error('Create doc subset error:', error);
      toast.error(error.message || 'Failed to create document subset. Please try again.');
    },
  });
};
